import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.indexOf('/api/') === -1) {
    return next(req);
  }
  const authService = inject(AuthService);
  let headers = req.headers;
  if (!(req.body instanceof FormData)) {
    headers = headers.set('Content-Type', 'application/json');
  }
  authService.isAuthenticated$.subscribe((isAuthenticated) => {
    if (isAuthenticated) {
      authService.getAccessToken().subscribe((token) => {
        if (token) {
          headers = headers.set('Authorization', `Bearer ${token}`);
        }
      });
      authService.getIdToken().subscribe((token) => {
        if (token) {
          headers = headers.set('x-id-token', token);
        }
      });
    }
  });
  const clonedRequest = req.clone({ headers });
  return next(clonedRequest);
};
